module.exports = __webpack_public_path__ + "img/016-composer.7130e5fd.png";